import type { StoryStatus } from '../api/abnahme';

/** Farbklassen je Story-Status — gleich in Etikett, Katalog und Abläufen. */
export const STORY_STATUS_KLASSE: Record<StoryStatus, string> = {
  entwurf: 'bg-muted text-muted-foreground',
  geplant: 'bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-100',
  in_umsetzung: 'bg-blue-100 text-blue-900 dark:bg-blue-950 dark:text-blue-100',
  bereit_zur_abnahme: 'bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-100',
  abgenommen: 'bg-emerald-100 text-emerald-900 dark:bg-emerald-950 dark:text-emerald-100',
  abgelehnt: 'bg-red-100 text-red-900 dark:bg-red-950 dark:text-red-100',
};
